(function () {
  "use strict";

  MultiEditCustomFieldsSidebarCtrl.$inject = ['$scope', 'usersResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('MultiEditCustomFieldsSidebarCtrl', MultiEditCustomFieldsSidebarCtrl);

  function MultiEditCustomFieldsSidebarCtrl($scope, usersResource) {
    $scope.customField = $scope.customFieldInEdit;
    $scope.editorText = '';

    var changes = {
      removedValues: [],
      applyToAllValue: -1
    };

    function exit() {
      clean();
      $scope.exitCustomFieldForMultipleEditor();
    }

    $scope.cancelChanges = function () {
      exit();
    };

    $scope.canApplyToAll = function () {
      return $.trim($scope.editorText);
    };

    $scope.canApplyChanges = function () {
      return $scope.manageUsersEditors.multiCustomFieldsEditor && !$scope.serverCallInProgress;
    };

    $scope.applyToAll = function (newValue) {
      newValue = newValue || $.trim($scope.editorText);

      if (changes.applyToAllValue === newValue)
        return;

      changes.removedValues = [];
      changes.applyToAllValue = newValue
      $scope.customField.values = [
        {value: newValue, count: 'All'}
      ];
      $scope.customField.hasMoreValues = false;
      $scope.editorText = '';
      markDirty();
    };

    $scope.removeValue = function (value) {
      if (changes.applyToAllValue === -1) {
        changes.removedValues.push(value);
        $scope.customField.values = _.reject($scope.customField.values, function (v) {
          return v.value == value;
        });
      }
      else {
        changes.applyToAllValue = null;
        $scope.customField.values = [];
      }
      markDirty();
    };

    function markDirty() {
      $scope.manageUsersEditors.multiCustomFieldsEditor = true;
    }

    function clean() {
      $scope.manageUsersEditors.multiCustomFieldsEditor = false;
      $scope.serverCallInProgress = false;
      $scope.hideSpinner();
    }

    $scope.applyChanges = function () {
      var saveData = {fieldIndex: $scope.customField.id};

      if (changes.applyToAllValue !== -1) {
        saveData.fieldValue = changes.applyToAllValue;
        saveData.userIds = _.pluck($scope.storedSelectedUsers, 'id');
      }
      else if (changes.removedValues.length > 0) {
        var fieldKey = 'customField' + $scope.customField.id;
        var idsLookup = {};
        _.each(changes.removedValues, function (rv) {
          _.chain($scope.storedSelectedUsers)
            .filter(function (u) {
              return u[fieldKey] == rv;
            })
            .pluck('id')
            .each(function (id) {
              idsLookup[id] = true;
            });
        });
        saveData.fieldValue = null;
        saveData.userIds = _.keys(idsLookup);
      }

      $scope.serverCallInProgress = true;
      $scope.showSpinner();
      usersResource.updateCustomField(saveData, function (res) {
        $scope.refreshSelectedUserInfo(function () {
          $scope.serverCallInProgress = false;
          exit();
        });
      });
    };

    $scope.$watch('selectedUsers', function () {
      if ($scope.selectedUsers) {
        $scope.storedSelectedUsers = $scope.selectedUsers.slice();
        $scope.headerText = $scope.storedSelectedUsers.length + " users selected";
      }
    });
  }

})();
